import { WorkflowType } from 'modules/domains';
import { DATE_FORMAT_WITH_COMMA_HOUR_MINS, displayDate, getNewDate } from 'utils/date';

export const filterDownIfAnyValuesIncludeFilterString = (
  data: Record<string, any>[],
  filter: string,
) => {
  if (!filter) {
    return data;
  }
  return data?.filter?.((row) =>
    Object?.values?.(row)?.some((value) =>
      value?.toString()?.toLowerCase()?.includes?.(filter?.toLowerCase()),
    ),
  );
};

export const paginateResults = (data: any, pagingDetails: { page: number; pageSize: number }) =>
  (data || []).slice(
    (pagingDetails.page - 1) * pagingDetails.pageSize,
    pagingDetails.page * pagingDetails.pageSize,
  );

export enum DownloadType {
  CSV = 'csv=true',
  JSON = 'inJson=true',
}

export const url = (downloadType: DownloadType, nodeId: number, workflowType?: WorkflowType) =>
  `/workflows/visitorsAtNode?workflowNodeId=${nodeId}&workflowType=${workflowType}&${downloadType}`;

export const getTableToolbarTitle = (
  totalVisitors: number,
  fetchedVisitors: number,
  tileId: number,
) => {
  if (totalVisitors > fetchedVisitors) {
    return `Latest ${fetchedVisitors}/${totalVisitors} users in tile (ID: ${tileId})`;
  }
  return `${totalVisitors} users in tile (ID: ${tileId})`;
};

/* this is added to match what the backend api used to return, userID is often empty */
export const nodeVisitorsHeaders = [
  { label: 'ID', key: 'id' },
  { label: 'User', key: 'user' },
  { label: 'Email', key: 'email' },
  { label: 'User ID', key: 'userId' },
  { label: 'Entered Journey', key: 'enteredJourney' },
  { label: 'Entered Tile', key: 'enteredTile' },
  { label: 'Delayed Until', key: 'delayedUntil' },
];

export const nodeVisitorsFileName = (workflowName: string) =>
  `${workflowName}-visitors-${displayDate(getNewDate(), 'MM_DD_YYYY_hh_mmA')}.csv`;

const formatDate = (d: Date) => displayDate(d, DATE_FORMAT_WITH_COMMA_HOUR_MINS);

const formatRowForCSV = (row: any) => {
  return {
    id: row?.id,
    user: row?.primaryValue,
    email: row?.email,
    userId: row?.userId,
    enteredJourney: formatDate(row?.createdAt),
    enteredTile: formatDate(row?.updatedAt),
    delayedUntil: formatDate(row?.delayedUntil),
  };
};

export const formatDataForCSV = (data: any[]) => {
  return data.map((d) => formatRowForCSV(d));
};
